import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authenticateForPdfUrlAccessCode, authenticateUrlAccessCode, logoutUser } from '../auth/auth-slice';
import { displayToast } from '../app/app-slice';

const KNOWN_ITEM_TYPES = ['issue', 'change_control'];

export function Authenticated(props) {
  const { urlCode } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userSlice = useSelector((state) => state.auth.user);
  const sessionSlice = useSelector((state) => state.auth.session);
  const [renderChildren, setRenderChildren] = useState(false);

  const { pdfVerify } = props;

  useEffect(() => {
    const loggedOutMessage =
      'You have been signed out since the item you are attempting to access belongs to another email. Please authenticate again to proceed.';

    if (!sessionSlice?.syncCompleted) {
      return;
    }

    if (sessionSlice?.conflict) {
      dispatch(logoutUser());
      dispatch(displayToast(loggedOutMessage));
      setRenderChildren(false);
      if (sessionSlice.conflictedItemAssignmentCode) {
        navigate('/' + sessionSlice.conflictedItemAssignmentCode);
      }
      return;
    }

    if (pdfVerify) {
      if (
        (urlCode &&
          (userSlice.itemAssignmentCodeAuthenticationStatus === 'Unauthenticated' ||
            userSlice.pdfIdentifier !== urlCode)) ||
        (userSlice.itemAssignmentCodeAuthenticationStatus === 'Unauthenticated' && userSlice.pdfIdentifier)
      ) {
        dispatch(
          authenticateForPdfUrlAccessCode({
            code: urlCode,
            navigate: navigate,
          })
        );
        setRenderChildren(false);
        return;
      }
    }

    if (!pdfVerify) {
      if (
        (urlCode &&
          (userSlice.itemAssignmentCodeAuthenticationStatus === 'Unauthenticated' ||
            userSlice.itemAssignmentCode !== urlCode)) ||
        (userSlice.itemAssignmentCodeAuthenticationStatus === 'Unauthenticated' && userSlice.itemAssignmentCode)
      ) {
        dispatch(
          authenticateUrlAccessCode({
            code: urlCode || userSlice.itemAssignmentCode,
            navigate: navigate,
          })
        );

        setRenderChildren(false);
        return;
      }
    }

    if (
      userSlice.pdfIdentifier &&
      userSlice.itemAssignmentCodeAuthenticated &&
      userSlice.emailAuthenticated &&
      userSlice.secretCodeAuthenticated
    ) {
      setRenderChildren(true);
      navigate(`/pdfs/${userSlice.pdfIdentifier}`);
      return;
    }

    if (
      userSlice.type === 'folder-share' &&
      userSlice.itemAssignmentCodeAuthenticated &&
      userSlice.emailAuthenticated &&
      userSlice.secretCodeAuthenticated
    ) {
      setRenderChildren(true);
      navigate('/view-folder-share');
      return;
    }

    if (
      userSlice.type === 'document' &&
      userSlice.itemAssignmentCodeAuthenticated &&
      userSlice.emailAuthenticated &&
      userSlice.secretCodeAuthenticated
    ) {
      setRenderChildren(true);
      navigate('/view-document');
      return;
    }

    if (
      userSlice.itemAssignmentCodeAuthenticated &&
      userSlice.emailAuthenticated &&
      userSlice.secretCodeAuthenticated
    ) {
      setRenderChildren(true);
      if (KNOWN_ITEM_TYPES.includes(userSlice.type)) {
        navigate('/view-issue');
      } else {
        navigate('/view-item');
      }
      return;
    }

    if (userSlice.itemAssignmentCodeAuthenticated && userSlice.emailAuthenticated) {
      setRenderChildren(true);
      navigate('/verify-securityCode');
      return;
    }

    if (userSlice.itemAssignmentCodeAuthenticated) {
      setRenderChildren(true);
      navigate('/verify-email');
      return;
    }
    setRenderChildren(false);
  }, [
    userSlice.itemAssignmentCodeAuthenticated,
    userSlice.itemAssignmentCodeAuthenticationStatus,
    userSlice.pdfIdentifier,
    userSlice.itemAssignmentCode,
    userSlice.emailAuthenticated,
    userSlice.secretCodeAuthenticated,
    userSlice.type,
    sessionSlice,
    pdfVerify,
    urlCode,
  ]);

  return <>{renderChildren && props.children}</>;
}
